import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Grid from '@mui/material/Grid2';
import { 
  ModelBase
} from "@models";
import { 
  Table, 
  TableBase, 
} from "@dndModels";
import { CHARACTER_LEVELS, FEATURE_SOURCE_TYPE_OPTIONS } from "@dndModels/Constants";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import LoadingBox from "@components/input/LoadingBox";
import TableInput from "@dndComponents/other/TableInput";
import { DataType } from '@dndModels/Types';

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function TableEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<Table>(api.applyWorkingOn(new Table()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if(!fetched) {
      load();
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    setFetched(true);
    // debugger;
    if (id && id !== "") {
      setLoading(true);
      load_object(id);
    } else {
      // It's here from clicking Create on index.  
      // If the user is not admin, then we need to give the floating feature their id as owner or it will be disabled.
      const new_obj = obj;
      if (api.user && !api.user.admin && new_obj.name === "" && new_obj.owner_id === "") {
        new_obj.owner_id = api.user._id;
      }
      setObj(new_obj);
    }
  }

  // Loads the editing Table into state
  const load_object = (id: string) => {
    api.getFullObject("table", id).then(res => {
      if (res instanceof Table) {
        setObj(res);
        setLoading(false);
      }
    });
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("table", obj).then(res => {
  //       if (res && res.body.id) {
  //         obj._id = res.body.id;
  //       } 
  //       setProcessing(false);
  //       setNavigateTo("/dandd/table");
  //     });
  //   }
  // }

  const height = window.innerHeight - 64;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else {
    let level_options = [...CHARACTER_LEVELS];
    level_options = level_options.filter(o => obj.entries.filter(o2 => `${o2.level}` === o).length === 0);
    if (obj.entries.filter(o => o.level === 20).length === 0) {
      level_options.push("Next");
    }
    return (
      <ModelBaseInput
        obj={obj}
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: ModelBase) => {
          if (changed instanceof Table) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
            setChangeTime(common_util.get_time_number());
          }
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <SelectStringBox 
              name="Type"
              value={obj.type} 
              options={FEATURE_SOURCE_TYPE_OPTIONS}
              disabled={disabled}
              onChange={(changed: DataType) => {
                const new_obj = obj;
                new_obj.type = changed;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            { obj.type !== "" &&
              <SelectObjectBox 
                name="For"
                value={obj.for_id} 
                data_type={obj.type}
                disabled={disabled}
                // log_it
                onChange={(changed: string) => {
                  const new_obj = obj;
                  new_obj.for_id = changed;
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            }
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <TableInput
              obj={obj}
              disabled={disabled}
              onChange={(changed: TableBase) => {
                const new_obj = obj;
                new_obj.copyBase(changed);
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
        </Grid>
      </ModelBaseInput>
    );
  }
}
